/**
 * Number formatting utilities — port of monolith fmt/fmtM/fmtCHF (lines 538-540).
 * Accepts locale parameter for i18n support.
 */

export function fmt(n: number | null | undefined, locale = 'fr-CH'): string {
  if (n == null) return '\u2014'; // em dash
  return new Intl.NumberFormat(locale).format(Math.round(n));
}

export function fmtM(n: number | null | undefined, _locale = 'fr-CH'): string {
  if (n == null) return '\u2014';
  if (Math.abs(n) >= 1e9) return `${(n / 1e9).toFixed(2)} Mrd`;
  return `${(n / 1e6).toFixed(1)} M`;
}

export function fmtCHF(n: number | null | undefined, locale = 'fr-CH'): string {
  return `CHF ${fmtM(n, locale)}`;
}

export function fmtCurrency(
  n: number | null | undefined,
  locale = 'fr-CH',
  currency = 'CHF',
): string {
  if (n == null) return '\u2014';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.round(n));
}

export function fmtPct(n: number | null | undefined, decimals = 1): string {
  if (n == null) return '\u2014';
  return `${n.toFixed(decimals)}%`;
}
